import { startTransition } from 'react';
import type { UpdateParam } from '../../../store/types';

/**
 * Returns a callback that applies a filter update, commits to applied filters,
 * and optionally invokes onAfterChange (e.g. for scroll-back behavior).
 */
export function createApplyAndNotify(
  handleSingleFormUpdate: (param: UpdateParam) => void,
  handleApplyFilters: () => void,
  onAfterChange?: () => void,
): (param: UpdateParam) => void {
  return param => {
    startTransition(() => {
      handleSingleFormUpdate(param);
      handleApplyFilters();
      onAfterChange?.();
    });
  };
}
